module.exports = {
    "removeButtonLabel": `Remover`,
    "removeDescription": `Pressione Delete para remover a tag.`
};


//# sourceMappingURL=pt-BR.main.js.map
